import { render, staticRenderFns } from "./p-server-side-importer.vue?vue&type=template&id=3f558b4e&"
import script from "./p-server-side-importer.vue?vue&type=script&lang=js&"
export * from "./p-server-side-importer.vue?vue&type=script&lang=js&"
import style0 from "./p-server-side-importer.vue?vue&type=style&index=0&id=3f558b4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports